import { Wifi, WifiOff, RefreshCw } from "lucide-react";
import { useConnection } from "../hooks/useConnection";
import { syncNow } from "../lib/offlineQueue";

export function ConnectionStatus({ compact = false }) {
  const { online, pending } = useConnection();

  return (
    <div
      data-testid="connection-status"
      data-online={online ? "true" : "false"}
      className={`flex items-center gap-2 rounded-xl font-semibold ${
        compact ? "px-2 py-1 text-xs" : "px-3 py-2 text-sm"
      } ${
        online
          ? "bg-[#16A34A]/15 text-[#16A34A]"
          : "bg-[#DC2626]/15 text-[#DC2626]"
      }`}
    >
      {online ? <Wifi size={compact ? 14 : 16} /> : <WifiOff size={compact ? 14 : 16} />}
      <span data-testid="connection-label">{online ? "En línea" : "Sin conexión"}</span>
      {pending > 0 && (
        <button
          type="button"
          onClick={() => online && syncNow()}
          data-testid="pending-sync-count"
          title="Ventas pendientes de sincronizar"
          className="flex items-center gap-1 bg-[#F59E0B]/20 text-[#B45309] rounded-full px-2 py-0.5 text-xs"
        >
          <RefreshCw size={12} className={online ? "animate-spin-slow" : ""} />
          {pending}
        </button>
      )}
    </div>
  );
}
